import React, {useState} from 'react'

import {H3, H5, Button, Alert, Link} from '../../../../components/UI/index.js'
import {FormStack, Toggle, Input, Select} from '../../../../components/UI/forms/index.js'

import LoginActions from '../../../../actions/LoginActions.js'
import t from '../../../../helpers/Languages.js'
import {Customer} from '../../../../../server/functions/customers/customers.types.js'

interface PrestaShopSettingsProps {
    user: Customer
    onChange: (user: Customer, save?: boolean) => void
}

export default function PrestaShopSettings({user, onChange}: PrestaShopSettingsProps) {
    const [loading, setLoading] = useState(false)
    const [verified, setVerified] = useState(false)
    const [error, setError] = useState('')

    const onChangeChecked = (key: string, event: {target: {checked: boolean}}) => {
        user.settings.webshops.prestashop[key] = event.target.checked

        onChange(user)
    }

    const onChangeValue = (key: string, event: React.ChangeEvent<HTMLInputElement>, parser?: (value: string) => number) => {
        user.settings.webshops.prestashop[key] = parser ? parser(event.target.value) : event.target.value

        onChange(user)
    }

    const onDownloadPlugin = () => {
        const path = `/downloads/veloydpickuppoints.zip`
        const name = 'veloydpickuppoints.zip'
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.setAttribute('style', 'display: none;')
        a.href = path
        a.download = name
        a.click()
        document.body.removeChild(a)
    }

    const onVerifyConnection = () => {
        setLoading(true)
        setVerified(false)

        onChange(user, true)

        setTimeout(() => { // wait for saving
            LoginActions.verifyWebshop('prestashop', (err) => {
                setLoading(false)
                if (err) {
                    setError(`Verificatie niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`)
                } else {
                    setError('')
                    setVerified(true)
                }
            })
        }, 1000)
    }

    return (
        <div>
            <H3 style={{marginBottom: 36}}>PrestaShop</H3>

            <H5 style={{marginBottom: 24}}>Instellingen</H5>

            <FormStack>
                <Toggle
                    label='Actief'
                    checked={user.settings.webshops.prestashop.active}
                    onChange={(event) => onChangeChecked('active', event)}
                />

                {user.settings.webshops.prestashop.active &&
                    <>
                        <Input
                            label='Webshop URL'
                            value={user.settings.webshops.prestashop.url}
                            onChange={(event) => onChangeValue('url', event)}
                        />

                        <Input
                            label='API key'
                            value={user.settings.webshops.prestashop.apiKey}
                            onChange={(event) => onChangeValue('apiKey', event)}
                        />

                        <Input
                            type='number'
                            min={1}
                            max={180}
                            label='Aantal dagen terugkijken voor ophalen bestellingen'
                            value={user.settings.webshops.prestashop.nrOfDays || 7}
                            onChange={(event) => onChangeValue('nrOfDays', event, parseInt)}
                        />

                        <Select
                            label='Update bestelling status in PrestaShop'
                            info={'Update order status \'Shipped\' in PrestaShop'}
                            value={user.settings.webshops.prestashop.updateStatus}
                            onChange={(event) => onChangeValue('updateStatus', event)}
                        >
                            <option value=''>Nooit</option>
                            <option value='confirm'>Na bevestigen</option>
                            <option value='afterSent'>Na verzenden</option>
                        </Select>

                        <Toggle
                            label='Consument opmerking meegeven als bezorginstructie'
                            checked={!!user.settings.webshops.prestashop.useComment}
                            onChange={(event) => onChangeChecked('useComment', event)}
                        />

                        <div>
                            <Link style={{marginTop: 12}} onClick={onDownloadPlugin} info={t('prestaShopPickupPluginInfo')}>Download afhaalpunten plugin</Link>

                            <Link style={{fontWeight: 'normal'}} href='https://handleiding.veloyd.nl/docs/prestashop/'>{t('prestaShopPickupPluginManual')}</Link>
                        </div>

                        <Button
                            variant='text'
                            loading={loading}
                            onClick={onVerifyConnection}
                        >
                            Verifieër
                        </Button>

                        {error && (
                            <Alert style={{marginBottom: 6}} onClose={() => setError('')} variant='error'>{error}</Alert>
                        )}

                        {!error && verified && (
                            <Alert style={{marginBottom: 6}} onClose={() => setVerified(false)}>Verificatie succesvol.</Alert>
                        )}
                    </>
                }
            </FormStack>
        </div>
    )
}
